export default {
  presenter: 'caletka',
  title: 'Analýza měření RIPE Atlas v Pythonu',
  subtitle: 'pokročilí/zkušení administrátoři/programátoři',
  text: `
Systém RIPE Atlas je distribuovaný systém na měření základních parametrů internetu jako doba
odezvy, traceroute, nebo DNS. Naměřené hodnoty jsou k dispozici jako otevřená data a to i ve
formě živého streamu. Na workshopu si zkusíme pohrát s Pythoními knihovnami, které v rámci
projektu vznikly a zkusíme si naprogramovat nějakou zajímavou analýzu dat. Účastníci workshopu
by měli mít vlastní počítač s pythonem a měli by být schopni psát v pythonu jednoduché programy.
  `,
}



// WEBPACK FOOTER //
// ./src/content/installfest/data/presentations/caletka-ripe.js